module.exports = __webpack_public_path__ + "static/media/sss-auto-bumper_selected.e8e0da05.svg";